import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { HelpersService } from '../../../../core/services/helpers.service';
import { ModalNotifyService } from '../../../../core/services/modal-notify.service';
import { OperationsService } from '../../../../core/services/operations.service';
import { ClassificazionePraticaFormComponent } from '../../../form/classificazione-pratica-form.component';
import { Classificazione } from '../../../models/classificazione';
import { ClassificazioneResponse } from '../../../models/dto/classificazione-response';
import { ClassificazioneSezione } from '../../../models/sezioni/classificazione-sezione';

@Component({
    selector: 'div [classificazione-pratica-update]',
  templateUrl: '../../../form/classificazione-pratica-form.component.html',
  host: { '[class.col-sm-12]': '\'true\'', '[class.coldx]': '\'true\'' }
})

export class ClassificazionePraticaUpdateComponent extends ClassificazionePraticaFormComponent implements OnInit {
  private classificazione: Classificazione;
  private idSezione: string;
  private urlUpdateClassificazione: string;

  @Output()
  onReturn: EventEmitter<ClassificazioneSezione> = new EventEmitter<ClassificazioneSezione>();

  constructor(@Inject(HelpersService) helpersService: HelpersService, @Inject(FormBuilder) campiForm: FormBuilder, @Inject(ModalNotifyService) mns: ModalNotifyService, private operationService: OperationsService) {
      super(helpersService, campiForm, mns);
  }

  ngOnInit() {
    this.setTitle('Classificazione');
    this.isInserimento(false);
  }

  getRequest(request: Classificazione, manageCall: {executeCall: boolean, closeModal: boolean}) {
    if (manageCall.executeCall) {
      this.operationService.updateClassificazione(this.urlUpdateClassificazione, this.idSezione, request)
      .subscribe(response => this.classificazioneUpdated(response));
    } else if (manageCall.closeModal) {
      this.onReturn.emit(null);
    }
  }

  classificazioneUpdated(response: ClassificazioneResponse) {
    if (response.returnCode === 'OK') {
      this.onReturn.emit(response.sezione);
    }
  }

  getClassificazione() {
    return this.classificazione;
  }

  inizializza(idSezione: string, urlUpdateClassificazione: string, classificazione: Classificazione, idPratica: string, listaClassificazioni: Classificazione[]) {
    this.idSezione = idSezione;
    this.urlUpdateClassificazione = urlUpdateClassificazione;
    this.classificazione = classificazione;
    this.setIdTipoPratica(idPratica);
    this.inizializzaForm(listaClassificazioni);
  }

  canCheckPrimary(): boolean {
    return this.inserimento;
  }
}
